import { render, staticRenderFns } from "./MyNotificationSubscriptions.vue?vue&type=template&id=16aba06a&scoped=true&"
import script from "./MyNotificationSubscriptions.vue?vue&type=script&lang=js&"
export * from "./MyNotificationSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./MyNotificationSubscriptions.vue?vue&type=style&index=0&id=16aba06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aba06a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
